/*
 * export enum VERIFY_TYPE_VALUE {
 * "未认证" = 0,
 * "个人认证" = 1,
 * "企业认证" = 2,
 * "认证审核中" = -1,
 * "认证待审核" = -3,
 * "认证未通过" = -2
 * }
 */
export var VERIFY_TYPE_VALUE;
(function (VERIFY_TYPE_VALUE) {
    VERIFY_TYPE_VALUE[VERIFY_TYPE_VALUE["\u672A\u8BA4\u8BC1"] = 0] = "\u672A\u8BA4\u8BC1";
    VERIFY_TYPE_VALUE[VERIFY_TYPE_VALUE["\u4E2A\u4EBA\u8BA4\u8BC1"] = 1] = "\u4E2A\u4EBA\u8BA4\u8BC1";
    VERIFY_TYPE_VALUE[VERIFY_TYPE_VALUE["\u4F01\u4E1A\u8BA4\u8BC1"] = 2] = "\u4F01\u4E1A\u8BA4\u8BC1";
    VERIFY_TYPE_VALUE[VERIFY_TYPE_VALUE["\u4F01\u4E1A\u8BA4\u8BC1\u5F85\u5BA1\u6838"] = -1] = "\u4F01\u4E1A\u8BA4\u8BC1\u5F85\u5BA1\u6838";
    VERIFY_TYPE_VALUE[VERIFY_TYPE_VALUE["\u4E2A\u4EBA\u5347\u7EA7\u4F01\u4E1A\u5F85\u5BA1\u6838"] = -3] = "\u4E2A\u4EBA\u5347\u7EA7\u4F01\u4E1A\u5F85\u5BA1\u6838";
    VERIFY_TYPE_VALUE[VERIFY_TYPE_VALUE["\u4F01\u4E1A\u8BA4\u8BC1\u5BA1\u6838\u4E0D\u901A\u8FC7"] = 102] = "\u4F01\u4E1A\u8BA4\u8BC1\u5BA1\u6838\u4E0D\u901A\u8FC7";
    VERIFY_TYPE_VALUE[VERIFY_TYPE_VALUE["\u4E2A\u4EBA\u5347\u7EA7\u4F01\u4E1A\u5BA1\u6838\u4E0D\u901A\u8FC7"] = 101] = "\u4E2A\u4EBA\u5347\u7EA7\u4F01\u4E1A\u5BA1\u6838\u4E0D\u901A\u8FC7";
})(VERIFY_TYPE_VALUE || (VERIFY_TYPE_VALUE = {}));
